import { AfterViewInit, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { CustomService } from "src/app/services/custom/custom.service";
import { GenerateErrors } from "src/app/utils/generate-errors";
import { Webflow } from "src/app/utils/webflow";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";

@Component({
  selector: "app-passculture",
  templateUrl: "./passculture.component.html",
  styleUrls: ["./passculture.component.scss"],
})
export class PasscultureComponent implements OnInit, AfterViewInit {
  form: FormGroup;
  submitted = false;

  constructor(
    private customService: CustomService,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      contremarque: [
        "",
        [Validators.required],
      ],
    });
  }

  ngOnInit(): void {
    
  }

  ngAfterViewInit(): void {
    Webflow.setIFrameHeight();
  }

  get controls() {
    return this.form.controls;
  }

  changeTextToUppercase(field) {
    const obj = {};
    obj[field] = this.form.controls[field].value.toUpperCase();
    this.form.patchValue(obj);
  }

  onSubmit() {
    if (this.form.invalid) {
      Webflow.setIFrameHeight();
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Veuillez vérifier vos informations",
        confirmButtonText: "OK",
        position: "top",
      });
      return;
    }

    this.spinner.show();
    this.customService
      .validate_reservation_passculture(this.form.value.contremarque)
      .subscribe(
        (res) => {
          Webflow.setIFrameHeight();
          Swal.fire({
            title: "Validation contremarque",
            text: "La contremarque a été validée avec avec succès",
            icon: "success",
            position: "top",
          });
        },
        (error) => {
          if (GenerateErrors.check_if_is_custom_error(error)) {
            Swal.fire({
              title:
                GenerateErrors.get_error_id(error) == "passculture.coming.soon"
                  ? "En maintenance"
                  : "Attention",
              text: GenerateErrors.get_message_error(error),
              icon: "info",
              position: "top",
            });
          } else {
            Swal.fire({
              title: "Erreur",
              text: "Erreur de connexion",
              icon: "error",
              position: "top",
            });
          }
          Webflow.setIFrameHeight();
        }
      )
      .add(() => {
        this.spinner.hide();
      });
  }

  handleKeyUp(e) {
    if (e.keyCode === 13) {
      this.onSubmit();
    }
  }
}
